import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom';
import OverrideForecastDialog from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/recommendations/dialogs/override-forecast-dialog';
import SkippedDialog from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/recommendations/dialogs/skipped-dialog';
import { useOrdersState } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/context/orders-context';
import { OFD2Params } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/ofd-2-params.type';
import { Recommendation } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/recommendation-assortment.type';
import { useGoogleTagManager } from 'views/order-feed/features/my-supply-plan/hooks/use-google-tag-manager';
import { OrderType, SupplyPlanType } from 'views/order-feed/features/my-supply-plan/types/google-tag-manager/order-feed-events.type';

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.orders.list';

type Props = {
  recommendation: Recommendation;
};

const RecommendationActions: React.FC<Props> = ({ recommendation }) => {
  const history = useHistory();
  const params = useParams<OFD2Params>();
  const { createOrderFeedEvent } = useGoogleTagManager();
  const { orderSettingsQuery } = useOrdersState();

  const isSkipped = recommendation.autoSkipped || recommendation.manuallySkipped;

  const goToInputSettings = () => {
    const { siteErpId, globalSiteId } = params;
    history.push(`/order-feed/supply-plan/order-free-delivery/${siteErpId}/${globalSiteId}/input-settings`);
  };

  return (
    <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
      <Box>
        <Typography fontWeight={'bold'}>
          <FormattedMessage id={`${PAGE_NAME_ID}.body.titleQuestion`} values={{ type: '' }} />
        </Typography>
        <Typography>
          <FormattedMessage id={`${PAGE_NAME_ID}.body.messageAnswer`} values={{ type: '' }} />
        </Typography>
      </Box>
      <Box display={'flex'}>
        <Box display={'flex'} gap={3}>
          <Button
            size="small"
            disabled={orderSettingsQuery.data?.isUnderMaintenance}
            onClick={() => {
              createOrderFeedEvent('adjust_settings', {
                orderType: OrderType.FORECAST,
                supplyPlanType: SupplyPlanType.OFD2,
              });

              goToInputSettings();
            }}>
            <FormattedMessage id={`${PAGE_NAME_ID}.adjustSettings`} values={{ type: '' }} />
          </Button>
          {isSkipped ? (
            <SkippedDialog recommendation={recommendation} />
          ) : (
            <OverrideForecastDialog recommendation={recommendation} />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default React.memo(RecommendationActions);
